<div *ngIf="userRole">
<div class="container-fluid header-nav">
  <nav class="navbar navbar-expand-lg navbar-light justify-content-between">
    <a class="navbar-brand" href="#">
      <img src="./assets/logo.png" width="150"  class="d-inline-block align-middle" alt="">
    </a>
   <!-- <div class="collapse navbar-collapse" id="navbarSupportedContent">
    <ul class="navbar-nav mr-auto">
      <li class="nav-item" [ngClass]="{'active': selectedService == 'insurance'}">
        <a class="nav-link" (click)="updatesSelectedService('insurance')" href="JavaScript:void(0);">Seguros</a>
      </li>
      <li class="nav-item" [ngClass]="{'active': selectedService == 'loans'}">
        <a class="nav-link" (click)="updatesSelectedService('loans')" href="JavaScript:void(0);">Financiamiento</a>
      </li>
    </ul>
    </div> -->
    <button class="navbar-toggler" type="button"  data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
  
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav mr-auto">
        <span id="mobile-menu">
        <div *ngFor="let page of activeMenu" >
          <li class="nav-item" >
            <a class="nav-link" [routerLinkActive]="['active']" routerLink="{{page.routerLink}}">
              {{page.page}}</a>
          </li>
        </div>
        
        </span>
        <li class="nav-item dropdown">
          
          <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          {{userFullName}}
          </a>
          <div class="dropdown-menu" aria-labelledby="navbarDropdown">
            <a class="dropdown-item" (click)="logout()">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
  </div>

  <div class="container-fluid ">
    <div class="row">
      <div class="col-1 side-nav" [style.display]="">
        <ul class="nav flex-column side-menu">
          <li class="nav-item" *ngFor="let page of activeMenu">   
            <a class="nav-link" [routerLinkActive]="['active']" routerLink="{{page.routerLink}}">
              <img src="./assets/icons/{{page.icon}}">
              <p>{{page.page}}</p></a>
          </li>
        </ul>
      </div>
      <div class="col-11 body">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>



<div *ngIf="userRole == null">
  <router-outlet></router-outlet>
</div>
  
<div *ngIf="loading" class="d-flex justify-content-center loading-screen">
  <div class="spinner-border" role="status">
    <span class="sr-only"></span>
  </div>
</div>
